import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: var(--lightBleu);
  position: relative;
  height: 100%;
  margin-bottom: var(--gap);
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
